//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const EmployeeFundsKanbanConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/ewa/kanban',
      component: FuseLoadable({
          loader: () => import('./Board')
      })
  }
  ]
  //end routes
};
